import { Link } from 'react-router-dom';
import { ca } from '../i18n/ca';
import { useAuth } from './AuthContext';

/**
 * A tester's first two moves (the owner, 2026-09-30): link Steam, so the game
 * knows whose answers and captures are whose, then open «Proves» and take a
 * card. Shown to an account with the Provador role on the first sign-in and on
 * the home page until both are done; an admin never needs it.
 */
export function TesterStart({
  where,
  steamLinked,
}: {
  where: 'welcome' | 'home';
  /** What the page already knows newer than the session's own list (a Steam id saved just now). */
  steamLinked?: boolean;
}) {
  const { me } = useAuth();
  const t = ca.testerStart;
  if (!me.authenticated || !me.roles.includes('TESTER') || me.roles.includes('ADMIN')) return null;
  const steam = steamLinked === true || me.identities.includes('STEAM');
  const took = me.tests === true;
  if (where === 'home' && steam && took) return null;
  return (
    <section className="card tester-start" aria-label={t.title}>
      <h2>
        <i className="bi bi-controller" aria-hidden="true" /> {t.title}
      </h2>
      <p className="muted small">{t.intro}</p>
      <ol className="tester-start-steps">
        <li className={steam ? 'done' : ''}>
          <strong>{t.steamTitle}</strong>{' '}
          {steam ? (
            <span className="chip ok small">{t.done}</span>
          ) : (
            <>
              <span>{where === 'welcome' ? t.steamHereHint : t.steamHint}</span>{' '}
              {where === 'home' && <Link to="/settings">{t.steamLink}</Link>}
            </>
          )}
        </li>
        <li className={took ? 'done' : ''}>
          <strong>{t.provesTitle}</strong> <span>{t.provesHint}</span>{' '}
          {where === 'home' && (
            <Link className="button primary" to="/proves">
              {t.provesLink}
            </Link>
          )}
        </li>
      </ol>
    </section>
  );
}
